import { Mentions } from "antd";
import type { FC } from "react";

import { useTranslation } from "src/translations";
import type { AntCustomFormField } from "../../types/types";
import { useLoadComponentConfigQuery } from "./configurationApi";

const { Option } = Mentions;

/**
 * Defines how many rows (height) have the Textarea components by default.
 * This value can be overridden by using the field properties defined in the json file.
 */
export const DEFAULT_FIELD_ROWS = 4;

export interface TextTemplatingProps extends AntCustomFormField<string> {
    name: string;
    label: string;
    readOnly: boolean;
    rows?: number;
}

export const TextTemplating: FC<TextTemplatingProps> = ({ onChange, rows, ...restProps }) => {
    const { t } = useTranslation();

    const { data } = useLoadComponentConfigQuery(`text-templating`);
    const options = data?.items || [];

    const onValueChange = (text: string) => {
        if (onChange) {
            onChange(text);
        }
    };

    return (
        <Mentions
            autoSize
            placeholder="type [ to see options"
            prefix="["
            rows={rows || DEFAULT_FIELD_ROWS}
            onChange={onValueChange}
            {...restProps}
        >
            {(options || []).map((option) => (
                <Option key={option.key} value={`${option.key}]`}>
                    {t(option.value)}
                </Option>
            ))}
        </Mentions>
    );
};
